
















import { Component, Vue } from "vue-property-decorator";

import { namespace } from "vuex-class";
import { getWallpaper, WallpaperInfo } from "../api";

const globalStore = namespace("global");

@Component
export default class PrettyBackground extends Vue {
  @globalStore.Getter loginBackground!: boolean;
  @globalStore.Getter branded!: boolean;

  visible = false;
  info: WallpaperInfo = {
    image_url: "",
    name: "",
    referral_url: "",
    unsplash_url: "",
  };

  get wallpaper(): HTMLElement {
    return this.$refs.wallpaper! as HTMLElement;
  }

  get orientation(): string {
    return window.screen.orientation.type.split("-")[0];
  }

  async setWallpaper(): Promise<void> {
    this.info = await getWallpaper(this.orientation);
    const url =
      this.info.image_url +
      "&h=" +
      String(screen.height) +
      "&w=" +
      String(screen.width) +
      "&fm=jpg&q=70&sat=-20&con=-20";

    var img = new Image();
    img.onload = () => {
      this.wallpaper.style.backgroundImage = `url("${url}")`;
      setTimeout(() => {
        this.visible = true;
      }, 1000);
    };
    img.src = url;
  }

  created(): void {
    if (!this.loginBackground) return;

    this.setWallpaper();
  }
}
